/*NUEVO RQTO HOJA DE VIDA PAGINA WEB, OA NOV 2025*/
import React, { Component, createRef } from 'react';
import '../responsive/TrabajeConNosotros.css';
import Footer from '../components/Principal/Footer';
import Header from '../components/Principal/Header';
import MensajeF from '../components/Mensaje_Flotante/MensajeF';
import Seccion1 from '../components/Trabaje con Nosotros/Seccion1';
import Seccion2 from '../components/Trabaje con Nosotros/Seccion2';
import SeccionCV from '../components/Trabaje con Nosotros/SeccionCV';

class TrabajeConNosotros extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadpage: false,
            /*NUEVO RQTO HOJA DE VIDA PAGINA WEB, OA NOV 2025*/
            currentView: 'main',
            selectedCargo: '',
            idVacante: 0,
        };

        /*NUEVO RQTO HOJA DE VIDA PAGINA WEB, OA NOV 2025*/
        this.sectionCV = createRef();
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({
                loadpage: true
            })
        }, 0.1)
    }

    /*NUEVO RQTO HOJA DE VIDA PAGINA WEB, OA NOV 2025*/
    mostrarSeccionCV = (nombcargo, idvacante) => {
        this.setState({
            currentView: 'cv',
            selectedCargo: nombcargo,
            idVacante: idvacante
        });
    }

    /*NUEVO RQTO HOJA DE VIDA PAGINA WEB, OA NOV 2025*/
    volverAlInicio = () => {
        this.setState({ currentView: 'main' });
    }

    render() {
        const { currentView, selectedCargo, idVacante } = this.state;
        /*SE EDITA ESTILO PARA RQTO HOJA DE VIDA - JPG NOV 2025*/
        return (
            <>
                <Header id={2} />
                <MensajeF />
                {this.state.loadpage ? (
                    <div>
                        {currentView === 'main' && (
                            <>
                                <Seccion1 />
                                <Seccion2 onPostulateClick={this.mostrarSeccionCV} />
                            </>
                        )}

                        {currentView === 'cv' && (
                            <div style={{ paddingTop: '15vh', backgroundColor: '#f6f7f8', minHeight: '100vh' }}>
                                <SeccionCV
                                    onBack={this.volverAlInicio}
                                    nombcargo={selectedCargo}
                                    idvacante={idVacante}
                                />
                            </div>

                        )}
                    </div>
                ) : (<React.Fragment></React.Fragment>)}
                <Footer />
            </>

        );
    }
}

export default TrabajeConNosotros;